import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { FormikFormGroup } from "components/common";
const FIELD_PREFIX = "snapshot_archiving_config";
const SnapshotFSPathFieldGroup = () => {
  const { t } = useTranslation("enterprise_archive");
  const { setFieldValue } = useFormikContext();
  const productName = useProductName();
  useEffect(
    () => () => {
      setFieldValue(`${FIELD_PREFIX}.path`, void 0);
    },
    [setFieldValue]
  );
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: `${FIELD_PREFIX}.path`,
      type: "text",
      label: t("snapshot_fs_path_field_group.path_label"),
      help: t("snapshot_fs_path_field_group.path_help", { product_name: productName }),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  );
};
export default SnapshotFSPathFieldGroup;
